import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { Form as AntdForm, FormProps, FormItemProps } from 'antd';

import './style.scss';

const PREFIX = 'music';

const _Form = (props: FormProps, ref: any) => {
  const {
    className,
    layout = 'vertical',
    autoComplete = 'off',
    requiredMark = true,
    ...rstProps
  } = props;

  return (
    // @ts-ignore - antd FormProps type compatibility
    <AntdForm
      className={classnames(`${PREFIX}-form`, className)}
      layout={layout}
      autoComplete={autoComplete}
      requiredMark={requiredMark}
      ref={ref}
      {...rstProps}
    />
  );
};

function FormItem(props: FormItemProps) {
  const { className, ...rstProps } = props;

  return <AntdForm.Item className={classnames(`${PREFIX}-form-item`, className)} {...rstProps} />;
}

type CompoundedComponent = React.ForwardRefExoticComponent<FormProps & React.RefAttributes<any>> & {
  Item: typeof FormItem;
  List: typeof AntdForm.List;
  useForm: typeof AntdForm.useForm;
  useFormInstance: typeof AntdForm.useFormInstance;
  useWatch: typeof AntdForm.useWatch;
};

const Form = forwardRef(_Form) as CompoundedComponent;

Form.Item = FormItem;
Form.List = AntdForm.List;
Form.useForm = AntdForm.useForm;
Form.useFormInstance = AntdForm.useFormInstance;
Form.useWatch = AntdForm.useWatch;

export default Form;
